<template>
    <div class="detail-view">
      <div class="title-box" @click.prevent="toggleInfo">
        <p class="view-title">
            <span v-html="contentInfo.title"></span>
        </p>
      </div>
      <div class="desc-info-box">
        <movie-genre :content-info="contentInfo"/>
      </div>
      <div class="icon-wrap">
        <icon-box-zzim-with-api v-if="!isPooqzone" section="movie" :content-id="contentId" :zzim="zzim"></icon-box-zzim-with-api>
        <a href="#" @click.prevent="moveToDetailInfo()">
          <div class="icon-box share">
            <detail-info-icon></detail-info-icon>
            <span class="icon-txt">상세정보</span>
          </div>
        </a>
        <a href="#" @click.prevent="moveToMovie" class="icon-box" v-if="contentInfo.originalmovieid !== ''">
          <IconMainMovie />
          <span class="icon-txt">본편 보기</span>
        </a>
      </div>

      <div class="selection-box" v-if="movieGroup.length > 0 && contentInfo.originalmovieid === ''">
        <label>
          <select v-model="selectedMovie" @change="goToSelectedMovie">
            <option v-for="(item, index) in movieGroup" :value="item.value" :key="item + '_' +index">{{item.text}}</option>
          </select>
        </label>
      </div>

      <apollo-player-action-button :click-player-fn="clickPlayerFn"
                            :content-info="contentInfo"
                            section="movie"
      ></apollo-player-action-button>

      <div class="desc-box">
        <p class="comment" v-if="comment !== ''">{{ comment }}</p>
        <p class="preview" v-if="synopsis !== ''" v-html="synopsis"></p>
      </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { MovieInfoService } from '@/common/api/api.service'
import router from '@/router'
import MovieGenre from '@/components/play/MovieGenre'
import { topTagList } from '@/common/directives'
import IconBoxSnsShare from '@/components/play/IconBoxSnsShare'
import IconMainMovie from '@/assets/svg/common/icon-main-movie.svg'
import utils from '@/common/util/utils'
import IconBoxZzimWithApi from '@/components/play/IconBoxZzimWithApi'
import { get } from 'lodash'
import {
  PATH_NAME_APOLLO_PLAYER,
  PATH_NAME_APOLLO_PLAYER_MOVIE_DETAIL_INFO
} from '@/common/router.const'
import DetailInfoIcon from '@/assets/svg/common/DetailInfoIcon.svg'
import ApolloPlayerActionButton from '@/components/play/apollo/ApolloPlayerActionButton'
export default {
  name: 'ApolloMoviePlayerDetailInfo',
  components: {
    ApolloPlayerActionButton,
    IconBoxZzimWithApi,
    IconBoxSnsShare,
    IconMainMovie,
    MovieGenre,
    DetailInfoIcon
  },
  directives: {
    topTagList
  },
  computed: {
    ...mapGetters(['userInfo']),
    zzim () {
      return get(this.contentInfo, 'zzim', 'n').toLowerCase()
    },
    contentId () {
      return get(this.contentInfo, 'movieid', '')
    },
    movieGroup () {
      return get(this.contentInfo, 'moviegroup.list', [])
    },
    comment () {
      return get(this.contentInfo, 'comment', '')
    },
    synopsis () {
      return get(this.contentInfo, 'synopsis', '')
    }
  },
  data () {
    return {
      isPooqzone: utils.cookies.isPooqZone(),
      selectedMovie: get(this.$route, 'query.movieid', '')
    }
  },
  methods: {
    moveToMovie () {
      MovieInfoService.getMovieMetaInfo({ movieID: this.contentInfo.originalmovieid }).then(({ data }) => {
        router.push({
          name: PATH_NAME_APOLLO_PLAYER,
          params: {
            section: 'movie'
          },
          query: { movieid: data.movieid }
        })
      }).catch((err) => {
        console.log(err, '컨텐츠 아이디 획득에 실패 했습니다.')
      })
    },
    moveToDetailInfo () {
      this.$router.push({
        name: PATH_NAME_APOLLO_PLAYER_MOVIE_DETAIL_INFO,
        query: {
          movieid: get(this.$route, 'query.movieid', '')
        }
      })
    },
    goToSelectedMovie () {
      this.$router.replace(`/apollo/player/movie?movieid=${this.selectedMovie}`)
    }
  },
  props: {
    contentInfo: { type: Object },
    getToggleButton: { type: String },
    toggleInfo: { type: Function },
    tagList: { type: Array },
    clickTag: { type: Function },
    clickPlayerFn: { type: Function },
    toggleState: { type: Boolean }
  },
  watch: {
    selected (newVal, oldVal) {
      const getMovieGroupItemByValue = (value) => {
        return get(this.contentInfo, 'moviegroup.list', []).filter((item, index) => {
          return item.text === value
        })[0]
      }
      if (newVal !== oldVal) {
        const newMovieGroupItem = getMovieGroupItemByValue(newVal)
        this.$router.push('/apollo/player/movie?movieid=' + get(newMovieGroupItem, 'value', ''))
      }
    }
  }
}
</script>
